import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  return (
    <div className="min-h-screen flex flex-col relative overflow-x-hidden">
      {/* Glow blobs behind content */}
      <div className="fixed -top-40 -left-40 w-[500px] h-[500px] bg-[#4b08ff]/45 rounded-full blur-[115px] pointer-events-none z-0" />
      <div className="fixed top-1/4 right-[-200px] w-[600px] h-[600px] bg-[#4b08ff]/35 rounded-full blur-[140px] pointer-events-none z-0" />
      <div className="fixed bottom-[-200px] left-10 w-[500px] h-[500px] bg-[#4b08ff]/40 rounded-full blur-[125px] pointer-events-none z-0" />
      
      <div className="relative z-10 flex flex-col min-h-screen w-full">
        <Navigation />
        <main className="flex-1">{children}</main>
        <Footer />
      </div>
    </div>
  );
};

export default Layout;
